// Libraries
import { useEffect } from 'react';

// Hooks
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import useSound from '../../../hooks/useSound';

// Features
import {
    selectSplashMessage,
    pushSplashMessage,
} from '../../../features/app/appSlice';
import { selectUser } from '../../../features/user/userSlice';

// Styles
import styles from './Splash.module.css';
// Utils
import playSound from '../../../utils/misc/playSound';
/**
 * @function Splash
 * Describes an update to the state of the game, e.g. winner
 *
 * @example
 * return (
 *   <Splash />
 * )
 */
function Splash(): JSX.Element {
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);
    const splashMessage = useAppSelector(selectSplashMessage);

    const voice = user.voice !== '' ? user.voice : 'default';
    const gameWonSoundUrl = `https://${process.env.REACT_APP_CDN}/play-bingo/audio/default/event.mp3`;
    const claimedBingoSoundUrl = `https://${process.env.REACT_APP_CDN}/play-bingo/audio/${voice}/bingo.mp3`;
    const noBingoSoundUrl = `https://${process.env.REACT_APP_CDN}/play-bingo/audio/${voice}/nobingo.mp3`;

    const gameWonSound = useSound(gameWonSoundUrl);
    const claimedBingoSound = useSound(claimedBingoSoundUrl);
    const noBingoSound = useSound(noBingoSoundUrl);

    useEffect(() => {
        if (splashMessage === "You've got bingo!" && user.sound_on === true)
            playSound(claimedBingoSound);
        if (splashMessage === 'We have a winner!' && user.sound_on === true)
            playSound(gameWonSound);
        if (
            splashMessage === 'You do not have bingo.' &&
            user.sound_on === true
        )
            playSound(noBingoSound);
    }, [splashMessage]);

    // Hide a splash message an amount of time, based on the message length,
    // after it is displayed
    useEffect(() => {
        const wordCount = splashMessage.split(' ').length;
        const interval = setInterval(() => {
            return dispatch(pushSplashMessage(''));
        }, wordCount * 500);
        return () => clearInterval(interval);
    }, []);

    return (
        <dialog className={`${styles.splash}`}>
            <p>{splashMessage}</p>
        </dialog>
    );
}

// Exports
export default Splash;
